import { z } from 'zod';
import { paginationSchema } from './common.js';

/**
 * Bewegungen sind die einzige Wahrheit über die Gerätehistorie.
 * Der Halter am Asset ist nur eine Denormalisierung für schnelle Listen.
 */
export const movementKindSchema = z.enum([
  'create', // Gerät angelegt
  'checkout', // an Person oder Standort übergeben
  'checkin', // ins Lager zurückgenommen
  'transfer', // direkt weitergereicht
  'status', // Statuswechsel ohne Halterwechsel (z. B. Verschrottung)
  'update', // Datenänderung
]);
export type MovementKind = z.infer<typeof movementKindSchema>;

export const MOVEMENT_KIND_LABELS: Record<MovementKind, string> = {
  create: 'Angelegt',
  checkout: 'Ausgegeben',
  checkin: 'Zurückgenommen',
  transfer: 'Übergeben',
  status: 'Status geändert',
  update: 'Bearbeitet',
};

const partySchema = z
  .object({
    type: z.enum(['employee', 'location', 'stock']),
    id: z.number().int().nullable(),
    name: z.string(),
  })
  .nullable();

export const movementSchema = z.object({
  id: z.number().int(),
  asset_id: z.number().int(),
  asset: z
    .object({
      id: z.number().int(),
      asset_tag: z.string(),
      serial: z.string(),
      model_name: z.string().nullable(),
    })
    .optional(),
  kind: movementKindSchema,
  from: partySchema,
  to: partySchema,
  status_from: z.string().nullable(),
  status_to: z.string().nullable(),
  note: z.string().nullable(),
  occurred_at: z.string(),
  actor: z.string().nullable(),
  /** Quelle der Änderung: Oberfläche, API-Token, MCP-Server oder Import. */
  source: z.enum(['ui', 'api', 'mcp', 'import', 'system']),
  has_protocol: z.boolean(),
  confirmed_at: z.string().nullable(),
  confirmation_pending: z.boolean(),
});
export type Movement = z.infer<typeof movementSchema>;

export const movementListQuerySchema = paginationSchema.extend({
  asset_id: z.coerce.number().int().positive().optional(),
  employee_id: z.coerce.number().int().positive().optional(),
  kind: movementKindSchema.optional(),
  from_date: z.string().optional(),
  to_date: z.string().optional(),
  pending_confirmation: z.coerce.boolean().optional(),
});
